<template>
  <div id="page-wrapper">
    <div class="g-logintime">
      <div class="g-userinfo">
        <div class="g-fixedimg flex-box" style="height: 100%;width:400px;float: left;">
          <div class="imgsboxs">
            <img v-if="adminPortraitUrl && adminPortraitUrl == null" :src="adminPortraitUrl" alt="">
            <img src="../assets/img/portrait.png" v-else alt="">
          </div>
          <div class="flex-box" style="flex: 1;flex-wrap: wrap">
            <div class="dropdownbox">
              <div class="el-dropdown-link">
                &nbsp;<span style="color:blue;margin-right: 10px">{{usernameview}}</span>您好！
              </div>
            </div>
            <el-popover placement="top-start" width="200" trigger="hover">
              <p>我的角色：<span v-for="item in detailrolds" style="margin-right:10px">{{item.role_name}}</span></p>
              <p class="ellipsis" slot="reference" style="width: 280px">我的角色：<span v-for="item in detailrolds" style="margin-right:10px">{{item.role_name}}</span></p>
            </el-popover>
           <!-- <p class="ellipsis" style="width: 280px">我的角色：<span v-for="item in detailrolds" style="margin-right:10px">{{item.role_name}}</span></p>-->
          </div>
        </div>
<!--        <div class="pull-right flex-box header_content">
          <div>
            <i></i>
            <span>修改密码</span>
          </div>
          <div style="height:50px;width: 1px;background: #a2a2a2;margin: 0 30px;"></div>
          <div>
            <i></i>
            <span >注销登录</span>
          </div>
        </div>-->
      </div>
    </div>
    <div class="g-companyinfo">
      <div class="flex-box" style="flex-wrap: wrap;justify-content: space-between">
        <div class="g-eveboxinfo flex-box" style="background:  rgba(39, 168, 226, 1)" v-if="$checkPermissions('customerManage')">
          <div class="g-percentage">
            <!--<img src="../assets/img/user.jpg" alt="">-->
            <img src="../assets/img/index1.png" alt="" class="gimgs">
            <!--<i class="imgIcon iconfont icon-banjiguanli"></i>-->
          </div>
          <div class="g-eveboxcont">
            <h4>{{userTotal}}</h4>
            <p class="ellipsis">客户总数</p>
          </div>
          <div class="position_content" @click="$router.push('/customerManage')" >
            <span>客户管理</span>
            <i>> </i>
          </div>
        </div>
        <div class="g-eveboxinfo flex-box" style="background:  rgba(39, 183, 121, 1)" v-if="$checkPermissions('orderManage')">
          <div class="g-percentage">
            <img src="../assets/img/index2.png" alt="" class="gimgs">
          </div>
          <div class="g-eveboxcont">
            <h4>{{orderTotal}}</h4>
            <p class="ellipsis">总订单量</p>
          </div>
          <div class="position_content" @click="$router.push('/businessOrderManage')">
            <span>订单管理</span>
            <i>> </i>
          </div>
        </div>
        <div class="g-eveboxinfo flex-box" style="background: rgba(133, 44, 154, 1)" v-if="$checkPermissions('businessmanManage')">
          <div class="g-percentage">
            <img src="../assets/img/index3.png" alt="" class="gimgs">
          </div>
          <div class="g-eveboxcont">
            <h4>{{storeTotal}}</h4>
            <p class="ellipsis">总客户数量</p>
          </div>
          <div class="position_content" @click="$router.push('/customerManage')">
            <span>客户管理</span>
            <i>> </i>
          </div>
        </div>
        <div class="g-eveboxinfo flex-box" style="background:  rgba(255, 183, 73, 1)" v-if="$checkPermissions('pagePublication')">
          <div class="g-percentage">
            <img src="../assets/img/index4.png" alt="" class="gimgs">
          </div>
          <div class="g-eveboxcont">
            <h4>{{activityTotal}}</h4>
            <p class="ellipsis">当前活动数</p>
          </div>
          <div class="position_content" @click="$router.push('/activityManage')">
            <span>活动管理</span>
            <i>> </i>
          </div>
        </div>
      </div>
      <div class="flex-box" style="justify-content: space-between;">
        <div class="g-chartlist">
          <h4>7日订单量变化趋势</h4>
          <div class="g-contlist" id="orderCharts">
          </div>
        </div>
        <div class="g-messagetx">
          <h4>客户新增量变化趋势</h4>
          <div class="g-contlist" id="customerCharts">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'
  var echarts = require('echarts');
  export default {
    data() {
      return {
        usernameview: '',
        activityTotal: '',
        userTotal: '',
        storeTotal: '',
        orderTotal: '',
        adminPortraitUrl: '',
        orderOptions: {},
        customerOptions: {},
        orderCharts: '',
        customerCharts: '',
        weekDate:['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        orderData:[320, 332, 301, 334, 390, 390, 390],
        userData:[220, 182, 191, 234, 290, 290, 290],
        data1:[],
        detailrolds:[],
      }
    },
    created() {
    },
    mounted() {
      this.detailrolds = JSON.parse(sessionStorage['detailrolds']);
      this.initindex();
      this.usernameview = sessionStorage['username'];
    },
    methods: {
      loginOut() {
        this.$router.push({path: '/login', query: {}})
      },
      windowSize(type) {
        let bodyClientWidth = document.body.clientWidth;
        this.orderCharts.resize();
        this.customerCharts.resize();
      },
      throttle(func, delay) { //函数节流
        var timer = null;
        var startTime = Date.now();
        return () => {
          var curTime = Date.now();
          var remaining = delay - (curTime - startTime);
          var context = this;
          var args = arguments;
          clearTimeout(timer);
          if (remaining <= 0) {
            func.apply(context, args);
            startTime = Date.now();
          } else {
            timer = setTimeout(func, remaining);
          }
        }
      },
      initindex() {
        getData.indexdetail().then((res) => {
          console.log(res.data.userList)
          console.log(res.data.orderList)
          this.orderData=res.data.orderList
          this.userData=res.data.userList
          this.weekDate=res.data.datenewList
          console.log(23,res.data.datenewList)
          this.userTotal = res.data.userTotal;
          this.activityTotal = res.data.activityTotal;
          this.storeTotal = res.data.storeTotal;
          this.orderTotal = res.data.orderTotal;
          this.tubiao()
        })
      },

      tubiao(){
        var _this = this;
        // 基于准备好的dom，初始化echarts实例
        this.orderCharts = echarts.init(document.getElementById('orderCharts'));
        this.customerCharts = echarts.init(document.getElementById('customerCharts'));
// 绘制图表
        this.orderOptions = {
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data:this.weekDate ,
            name: '',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#696969'
              },

            },
            axisTick: {
              show: false
            },
            boundaryGap: '5%'
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#dadada',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#696969'
              }
            },
            axisTick: {
              show: false
            }

          },
          series: [{
            //data: [820, 932, 901, 934, 1290, 1330, 1320],
            data: this.orderData,
            type: 'line',
            symbol: 'circle',
            symbolSize: 12,
            label: {
              normal: {
                show: true,
                position: 'top',
                color: '#696969'
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(55,160,233)',
                borderWidth: 2.5,
                borderColor: '#fff',
                shadowColor: 'rgba(0, 0, 0, 0.2)',
                shadowBlur: 3,
              },

            },
            lineStyle: {
              normal: {
                color: 'rgb(0,145,234)'
              }
            },
            areaStyle: {
              normal: {
                color: 'rgba(55,160,233,.08)',
              }
            },


          }]
        };
        var posList = [
          'left', 'right', 'top', 'bottom',
          'inside',
          'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
          'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
        ];
        app.configParameters = {
          rotate: {
            min: -90,
            max: 90
          },
          align: {
            options: {
              left: 'left',
              center: 'center',
              right: 'right'
            }
          },
          verticalAlign: {
            options: {
              top: 'top',
              middle: 'middle',
              bottom: 'bottom'
            }
          },
          position: {
            options: echarts.util.reduce(posList, function (map, pos) {
              map[pos] = pos;
              return map;
            }, {})
          },
          distance: {
            min: 0,
            max: 100
          }
        };
        app.config = {
          rotate: 90,
          align: 'left',
          verticalAlign: 'middle',
          position: 'insideBottom',
          distance: 15,
          onChange: function () {
            var labelOption = {
              normal: {
                rotate: app.config.rotate,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                position: app.config.position,
                distance: app.config.distance
              }
            };
            myChart.setOption({
              series: [{
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }]
            });
          }
        };
        var labelOption = {
          normal: {
            show: true,
            position: app.config.position,
            distance: app.config.distance,
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            rotate: app.config.rotate,
            formatter: '{c}  {name|{a}}',
            fontSize: 16,
            rich: {
              name: {
                textBorderColor: '#fff'
              }
            }
          }
        };

        this.customerOptions = {
          xAxis: {
            type: 'category',
            data: this.weekDate,
            name: '',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#696969'
              },

            },
            axisTick: {
              show: false
            },
            boundaryGap: '5%'
          },
          legend: {
            data: ['Forest', 'Steppe']
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: '#dadada',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#696969'
              }
            },
            axisTick: {
              show: false
            }

          },
          // series: [{
          //   //data: [820, 932, 901, 934, 1290, 1330, 1320],
          //   data: [],
          //   type: 'bar',
          //   symbol: 'circle',
          //   symbolSize: 12,
          //   label: {
          //     normal: {
          //       show: true,
          //       position: 'top',
          //       color: '#696969'
          //     }
          //   },
          //   itemStyle: {
          //     normal: {
          //       color: 'rgb(55,160,233)',
          //       borderWidth: 2.5,
          //       borderColor: '#fff',
          //       shadowColor: 'rgba(0, 0, 0, 0.2)',
          //       shadowBlur: 3,
          //     },
          //
          //   },
          //   lineStyle: {
          //     normal: {
          //       color: 'rgb(0,145,234)'
          //     }
          //   },
          //   areaStyle: {
          //     normal: {
          //       color: 'rgba(55,160,233,.08)',
          //     }
          //   },
          //
          //
          // }],
          series: [
            {
              name: 'Forest',
              type: 'bar',
              barGap: 0,
              label: labelOption,
              data: this.data1,
              itemStyle: {
                normal: {
                  color: '#5bdbeb',
                  borderWidth: 2.5,
                  borderColor: '#fff',
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowBlur: 3,
                },
              },
            },
            {
              name: 'Steppe',
              type: 'bar',
              label: labelOption,
              data: this.userData,
              itemStyle: {
                normal: {
                  color: '#828fdb',
                  borderWidth: 2.5,
                  borderColor: '#fff',
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowBlur: 3,
                },
              },
            },
          ]
        };

        this.orderCharts.setOption(this.orderOptions);
        this.customerCharts.setOption(this.customerOptions);
        window.onresize = global.throttle(this.windowSize, 100);
      },

      goUrl(path) {
        this.$store.state.localpath = path;
        this.$router.push(path)
      },
    },
    watch: {}
  }
</script>

<style lang="scss" scoped>
  #page-wrapper {
    position: relative;
    overflow: auto;
    font-family: '黑体-繁';
    /*margin-top: 51px;*/
  }

  .g-logintime {
    height: 122px;
    border-top: 1px solid #f8f8f9;
    background-color: #fefefe;
    border-left: 1px solid #f8f8f9;
    padding: 0 28px;
    position: relative;
    h4 {
      font-size: 26px;
      color: #546a79;
      line-height: 34px;
      margin-top: 21px;
    }
    p {
      line-height: 22px;
      font-size: 15px;
      color: #546a79;
    }
    .g-quickroad {
      position: absolute;
      top: 28px;
      right: 43px;
      width: 127px;
      height: 43px;
    }
  }

  .g-companyinfo {
    padding: 27px 25px 60px 28px;
  }

  .g-eveboxinfo {
    position: relative;
    border: 1px solid #e4e9f5;
    height: 145px;
    /*width: 370px;*/
    width: 24%;
    flex: none;
    min-width: 320px;
    box-shadow: 1px 1px 4px 3px rgba(12, 51, 92, 0.04);
    /* margin-right: 20px;*/
    margin-bottom: 20px;
    background-color: #fff;

  }

  .g-percentage {
    /*border-right: 1px solid #e0e7ee;*/
    padding-right: 4%;
    height: 112px;
    padding-left: 4%;
    width: 100px;
  }

  .g-eveboxcont {
    padding-right: 30px;
    justify-items: flex-start;
    width: calc(100% - 140px);
    text-align: right;
    h4 {
      color: #fff;
      line-height: 40px;
      margin-bottom: 4px;
      font-weight: 200;
      font-style: normal;
      font-size: 36px;
      cursor: pointer;
    }
    p {
      font-size: 14px;
      color: #fff;
      line-height: 30px;
    }
  }

  .g-chartlist {
    background-color: #FFFFFF;
    border: 1px solid #e2e7f4;
    width: 54%;
    margin-top: 20px;
    h4 {
      border-bottom: 1px solid #e2e7f4;
      line-height: 58px;
      color: #546a79;
      font-size: 16px;
      padding-left: 24px;
    }
    .g-contlist {
      height: 370px;
    }
  }

  .g-messagetx {
    background-color: #FFFFFF;
    border: 1px solid #e2e7f4;
    width: 44%;
    margin-top: 20px;
    h4 {
      border-bottom: 1px solid #e2e7f4;
      line-height: 58px;
      color: #546a79;
      font-size: 16px;
      padding-left: 24px;
    }
    .g-contlist {
      height: 370px;
      overflow-y: auto;
    }
  }

  .g-btnboxs {
    padding-top: 30px;
    padding-left: 24px;
    p {
      width: 127px;
      height: 43px;
      background-color: #fafafb;
      border: 1px solid #e3ebf8;
      border-radius: 4px;
      text-align: center;
      line-height: 43px;
      font-size: 16px;
      color: #9daeb8;
      margin-right: 26px;
      cursor: pointer;
    }
    .f-bluebtn {
      background-color: #0091ea;
      border-color: #0091ea;
      color: #fff;
    }
  }

  .g-messageinfos {
    padding: 8px 16px 20px 20px;
    .p-time {
      font-size: 13px;
      color: #c6d0d7;
      line-height: 20px;
      padding-bottom: 16px;
    }
    .g-messageinfos-eve {
      border-bottom: 1px dashed #e5eaed;
      height: 66px;
    }
    .g-messageinfos-nobot {
      border-bottom: 0 none;
    }
  }

  .g-newsinfo {
    margin-top: 20px;
    .g-newsinfo-left {
      width: 90%;
      p {
        line-height: 30px;
        color: #7f96a3;
        font-size: 16px;
        span {
          color: #0091ea;
          font-size: 16px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .g-newsinfo-right {
      line-height: 26px;
      i {
        color: #e5ecf1;
        cursor: pointer;
      }
    }

  }

  .g-userinfo {
    position: relative;
    height: 100%;
    border-bottom: 2px solid #f8f8f9;
    /*padding-top: 20px;*/
    .imgsboxs {
      position: relative;
      width: 100px;
      height: 100px;
      border: 1px solid #007de3;
      border-radius: 50%;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
      &:after {
        position: absolute;
        content: '';
        right: 12px;
        bottom: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #007de3;
        border: 1px solid #FFFFFF;
      }
    }
    .smallimgsboxs {
      position: absolute;
      margin: 0;
      top: 18px;
      left: 50%;
      margin-left: -26px;
    }
  }

  .imgIcon {
    width: 100px;
    height: 100px;
    font-size: 70px;
    line-height: 120px;
    margin-left: 12%;
    color: #3C8DBC;
  }

  .g-logintime {
    padding-top: 0;
    height: 160px;
  }

  .header_content {
    margin-top: 30px;
    margin-right: 30px;
    float: right;
    height: 80%;
    /*padding: 30px;*/
    span {
      font-size: 20px;
      font-weight: 700;
      color: #888;
    }
  }

  .position_content {
    position: absolute;
    /*bottom: 0;*/
    transition: all 1s;
    bottom: -33px;
    width: 100%;
    height: 33px;
    background: rgba(0, 0, 0, .3);
    color: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    display: none;
    span {
      font-size: 14px;
      line-height: 33px;
    }
    i {
      float: right;
      line-height: 33px;
    }
  }

  .g-eveboxinfo:hover {
    .position_content {
      transition: all 1s;
      bottom: 0;
      display: block;
    }
  }
  .gimgs{
    width: 80px;
    height: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue